import * as moment from 'moment';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { format } from 'date-fns';
import { Router } from '@angular/router';
import * as dayjs from 'dayjs';

export const MIN_DATE = new Date('1900-1-1');
export const MAX_DATE = new Date('9000-12-31');
export const AUTO_BILLING_ITEM = {
  // 入力計算方法
  INPUT_TYPE: {
    HAND: 1, // 都度手入力
    CONTRACT: 2, // 契約固定
    USAGE: 3, // 単価 x 使用量
    METER: 4, // 単価 x 検針値
    RENT: 100, // 売上歩合
    COMBINE: 5, // 固定＋売上歩合
    UNKNOWN: 999, // 不明
  },

  // 請求タイミング
  PAYMENT_TYPE: {
    LATER: 1, // 翌月払い(後払い)
    ADVANCE: 2, // 先払い
    TWO_MONTH_LATER: 3, // 翌々月払い
  },

  BILLING_PERIOD_TYPE: {
    EVERY_MONTH: 0, // 毎月
    ODD_MONTH: 1, // 奇数月
    EVEN_MONTH: 2, // 数月
  },
};

export const USER_ITEM = {
  USER_ROLE: {
    ROLE_ADMIN: '1',   // Admin
    ROLE_STAFF: '2',   // Nhân viên
    ROLE_MANAGER: '3', // Quản lý (slot cũ của Đại lý '3', tạm gỡ Đại lý)
  },
};

// Đăng nhập bằng SĐT + mật khẩu: Firebase Auth cần email nên ta ghép SĐT
// thành 1 email nội bộ ngầm. Nhân viên chỉ nhập SĐT; hệ tự ghép "@domain".
// Nếu người dùng nhập sẵn email (có '@', vd admin) thì giữ nguyên.
export const PHONE_LOGIN_DOMAIN = 'fox-staff.local';
export function phoneToLoginEmail(input: string): string {
  const v = (input || '').trim();
  return v.indexOf('@') !== -1 ? v : `${v}@${PHONE_LOGIN_DOMAIN}`;
}

export const invoice_number_Default = '000';
export const claim_number_Default = '000';
export const register_number_Default = '0000000000';

export const REGISTER_NUMBER = 'T5100001004919';

export const decimalMask: any = {
  mask: Number,
  signed: true, // Allow Negative
  scale: 20,
  padFractionalZeros: false,
  thousandsSeparator: ',',
  radix: '.',
  lazy: false, // make placeholder always visible
};

function convertStringToDate(date: string, format: string) {
  return moment(date, format).toDate();
}

function convertDateToString(date: string, format: string) {
  return moment(date).format(format);
}

function convertImageToBase64(url: string): Promise<string> {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.onload = function() {
      const reader = new FileReader();
      reader.onloadend = function() {
        resolve(reader.result as string);
      };
      reader.readAsDataURL(xhr.response);
    };
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    xhr.send();
  });
}

function toHaftWidth(chars: any) {
  var charString = '';
  for (var i = 0, l = chars.length; i < l; i++) {
    var c = chars[i].charCodeAt(0);

    // make sure only convert half-full width char
    if (c >= 0xff00 && c <= 0xffef) {
      c = 0xff & (c + 0x20);
    }

    charString += String.fromCharCode(c);
  }

  return charString;
}

function checkSpecialDay(date: any, lstDateSetting: any) {
  let isSpecialDay = false;
  let time = new Date(new Date(date).setHours(0, 0, 0, 0)).getTime();

  if (lstDateSetting.some((x: any) => x.date.seconds * 1000 === time)) {
    isSpecialDay = true;
  }

  return isSpecialDay;
}

function checkWeekenDay(date: any) {
  let isWeekenDay = false;

  if (new Date(date).getDay() === 6 || new Date(date).getDay() === 0) {
    isWeekenDay = true;
  }

  return isWeekenDay;
}

function getStartOfTheDay(date: Date) {
  const startDate = dayjs(date).startOf('day').toDate();
  return startDate;
}

function getEndOfTheDay(date: Date) {
  const endDate = dayjs(date).endOf('day').toDate();
  return endDate;
}

function getFiscalYearStringOfYearMonth(yearmonth: any, startMonth: any) {
  let year = moment(yearmonth, 'YYYYMM').format('YYYY');
  let month = moment(yearmonth, 'YYYYMM').format('MM');
  let fiscalYear = +year;
  if (+month < startMonth) {
    fiscalYear = +year - 1;
  }

  return fiscalYear.toString();
}

const randomString = (length = 5) => {
  let text = '';
  const possible =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789|+=';

  for (var i = 0; i < length; i++)
    text += possible.charAt(Math.floor(Math.random() * possible.length));

  return text;
};

const encodeData = (obj: any) => {
  if (typeof obj == 'boolean') {
    if (obj === true) {
      obj = true;
    } else {
      obj = false;
    }
  } else {
    obj = obj || obj === 0 ? obj : '';
  }

  let prefix = randomString(10);
  let suffix = randomString(8);
  const objs = JSON.stringify(obj);
  let sample = prefix + objs + suffix;
  let buffer = Buffer.from(sample, 'utf8').toString('base64');

  return buffer;
};

const decodeData = (sample: any) => {
  let obj = sample;
  if (typeof sample === 'string') {
    try {
      // remove prefix
      sample = sample.substring(10);
      // remove suffix
      sample = sample.slice(0, -8);
      let raw = sample.split('').reverse().join('');
      // eslint-disable-next-line no-undef
      let buffer = Buffer.from(raw, 'base64').toString('utf8');
      obj = JSON.parse(buffer);
    } catch (err) {
      // console.log(err);
    }
  }

  return obj;
};

function setParentRouting(router: any) {
  let lstRouter: any = [];
  let oldData = localStorage.getItem('parentRouting') || '';
  let parentRouting: any = oldData ? JSON.parse(oldData) : [];
  lstRouter = [...parentRouting, router];

  localStorage.setItem('parentRouting', JSON.stringify(lstRouter));
}

function getRouterParent() {
  let oldData = localStorage.getItem('parentRouting') || '';
  let parentRouting: any[] = oldData ? JSON.parse(oldData) : [];

  let lstRouter: any = [...parentRouting];
  parentRouting.splice(parentRouting.length - 1, 1);

  localStorage.setItem('parentRouting', JSON.stringify(parentRouting));
  return lstRouter[lstRouter.length - 1];
}

function setRouterParentRedirect(newRouter: any) {
  let oldData = localStorage.getItem('parentRouting') || '';
  let parentRouting: any[] = oldData ? JSON.parse(oldData) : [];

  let lstRouter: any = [...parentRouting];
  let index = lstRouter.findIndex((x: any) => x === newRouter);
  if (index && index > 0) {
    parentRouting = parentRouting.slice(0, index);
  } else {
    parentRouting = [];
  }

  localStorage.setItem('parentRouting', JSON.stringify(parentRouting));
}

function convertToHalf(val: any) {
  return val.toString().replace(/[！-～]/g, (halfwidthChar: any) => {
    return String.fromCharCode(halfwidthChar.charCodeAt(0) - 0xfee0);
  });
}

function convertNumber(val: any, lengReq: number) {
  let len = val.length;
  let result = val;
  while (len < lengReq) {
    result = '0' + result;
    len = result.length;
  }

  return result;
}

function getAllMonthInYear(currYearSelect: number | string, startMonthFiscalYear: number) {
  let data: any[] = [];
  for (let i = startMonthFiscalYear; i <= 12; i++) {
    let year_month = '';
    year_month = currYearSelect + '年' + (i < 10 ? `0${i}` : i) + '月';
    data.push({ year_month: year_month, bills: [] });
  }

  for (let i = 1; i <  startMonthFiscalYear; i++) {
    let year_month = '';
    year_month = +currYearSelect + 1 + '年' + (i < 10 ? `0${i}` : i) + '月';

    data.push({ year_month: year_month, bills: [] });
  }

  return data;
}

// //////////////////////////////////////////////////////////////////
class Utils {
  constructor() {}
  static getPaymentTypeText(payment_type: any) {
    if (!payment_type) return '';
    if (payment_type == AUTO_BILLING_ITEM.PAYMENT_TYPE.LATER) return '翌月払い';
    if (payment_type == AUTO_BILLING_ITEM.PAYMENT_TYPE.ADVANCE) return '先払い';
    if (payment_type == AUTO_BILLING_ITEM.PAYMENT_TYPE.TWO_MONTH_LATER)
      return '翌々月払い';
    return 'その他';
  }

  static getBillingPeriodTypeText(billing_period_type: any) {
    if (!billing_period_type && billing_period_type != 0) return '';
    if (
      billing_period_type == AUTO_BILLING_ITEM.BILLING_PERIOD_TYPE.EVERY_MONTH
    )
      return '毎月';
    if (billing_period_type == AUTO_BILLING_ITEM.BILLING_PERIOD_TYPE.ODD_MONTH)
      return '奇数月';
    if (billing_period_type == AUTO_BILLING_ITEM.BILLING_PERIOD_TYPE.EVEN_MONTH)
      return '偶数月';
    return '';
  }

  static getInputTypeText(input_type: any) {
    if (input_type == AUTO_BILLING_ITEM.INPUT_TYPE.HAND) return '手入力';
    if (input_type == AUTO_BILLING_ITEM.INPUT_TYPE.CONTRACT) return '契約固定';
    if (input_type == AUTO_BILLING_ITEM.INPUT_TYPE.USAGE) return '使用量計算';
    if (input_type == AUTO_BILLING_ITEM.INPUT_TYPE.METER) return '検針計算';
    if (input_type == AUTO_BILLING_ITEM.INPUT_TYPE.RENT) return '売上歩合';
    if (input_type == AUTO_BILLING_ITEM.INPUT_TYPE.COMBINE)
      return '固定＋超過歩合';
    return 'その他';
  }

  static showInInputPage(input_type: any, show_in_input_page: any) {
    if (
      input_type == AUTO_BILLING_ITEM.INPUT_TYPE.HAND ||
      input_type == AUTO_BILLING_ITEM.INPUT_TYPE.METER ||
      input_type == AUTO_BILLING_ITEM.INPUT_TYPE.USAGE
    ) {
      if (show_in_input_page == true) {
        return 'する';
      } else {
        return 'しない';
      }
    } else {
      return '-';
    }
  }

  static getTypeMonthText(month: any) {
    if (month == -2) return '2ヶ月前';
    if (month == -1) return '1ヶ月前';
    if (month == 0) return '当月';
    if (month == 1) return '1ヶ月後';
    return '';
  }

  static getTypeDayText(day: any) {
    if (!day) return '';
    if (day == 99) return '末日';
    return day + '日';
  }

  static getCalculationMethodOfTax(value: any) {
    if (value == 0) return '手入力';
    if (value == 1) return '総売上から計算(内税)';
    if (value == 2) return '総売上から計算(外税)';
    return '';
  }
  static getRoundMethodOfTax(value: any) {
    if (value == 0) return '切り捨て';
    if (value == 1) return '四捨五入';
    if (value == 2) return '切り上げ';
    return '';
  }
  static getCalculationMethodOfNetSales(value: any) {
    if (value == 0) return '手入力';
    if (value == 1) return '総売上と同額';
    if (value == 2) return '総売上-消費税1';
    return '';
  }

  static getDataTaxDefault(eventStoreData: any, tax_rate: any) {
    let lstDataTax = [];
    let line_1 = {
      id: '',
      content: '催事会場使用料',
      tax: tax_rate,
      is_textarea: true,
      amount: null,
    };

    let line_2 = {
      id: '',
      content: '駐車場使用料',
      tax: tax_rate,
      is_textarea: false,
      amount: eventStoreData?.parking_fee_amount,
    };

    let line_3 = {
      id: '',
      content: '貸出備品料',
      is_textarea: false,
      tax: tax_rate,
      amount: eventStoreData?.paid_rental_amount,
    };

    let line_4 = {
      id: '',
      content: '電源利用料',
      is_textarea: false,
      tax: tax_rate,
      amount: eventStoreData?.power_usage_amount,
    };
    lstDataTax = [line_1, line_2, line_3, line_4];
    return lstDataTax;
  }
}

export default Utils;

// convert img to base64:  https://base64.guru/converter/encode/image

export {
  convertStringToDate,
  convertDateToString,
  toHaftWidth,
  checkSpecialDay,
  checkWeekenDay,
  setParentRouting,
  getStartOfTheDay,
  getEndOfTheDay,
  getFiscalYearStringOfYearMonth,
  encodeData,
  decodeData,
  getRouterParent,
  setRouterParentRedirect,
  convertToHalf,
  convertNumber,
  getAllMonthInYear,
  convertImageToBase64
};
